import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GROUP_STATE_TYPE {
  activeGroupData: UserGroup & { type: 'admin' | 'sub' | '' };
  adminGroupsData: FullGroupDataFormat;
  isEditingGroup: boolean;
  isGroupViewActive: boolean;
  selectedStudentData: GroupListUserLimited | undefined;
  expandedGroupIds: Array<string>;
  viewingStudentActivity: boolean;
}

const INITIAL_STATE: GROUP_STATE_TYPE = {
  activeGroupData: { id: '', name: '', users: [], courses: [], group_code: '', type: '' },
  adminGroupsData: { groups: [], sub_groups: [] },
  isEditingGroup: false,
  isGroupViewActive: true,
  selectedStudentData: undefined,
  expandedGroupIds: [],
  viewingStudentActivity: false,
};

const adminGroupSlice = createSlice({
  name: 'admin-groups',
  initialState: INITIAL_STATE,
  reducers: {
    setActiveGroupData(
      state: GROUP_STATE_TYPE,
      action: PayloadAction<UserGroup & { type: 'admin' | 'sub' | '' }>,
    ) {
      state.activeGroupData = action.payload;
    },
    resetActiveGroupData(state: GROUP_STATE_TYPE) {
      state.activeGroupData = INITIAL_STATE.activeGroupData;
    },
    setAdminGroupsData(state: GROUP_STATE_TYPE, action: PayloadAction<FullGroupDataFormat>) {
      state.adminGroupsData = action.payload;
    },
    setIsEditingGroup(state: GROUP_STATE_TYPE, action: PayloadAction<boolean>) {
      state.isEditingGroup = action.payload;
    },
    setIsGroupViewActive(state: GROUP_STATE_TYPE, action: PayloadAction<boolean>) {
      state.isGroupViewActive = action.payload;
    },
    setSelectedStudentData(
      state: GROUP_STATE_TYPE,
      action: PayloadAction<GroupListUserLimited | undefined>,
    ) {
      state.selectedStudentData = action.payload;
    },

    setExpandedGroupIds(state: GROUP_STATE_TYPE, action: PayloadAction<string>) {
      if (state.expandedGroupIds.includes(action.payload)) {
        state.expandedGroupIds = state.expandedGroupIds.filter((id) => id != action.payload);
      } else {
        state.expandedGroupIds.push(action.payload);
      }
    },
    setViewingStudentActivity(state: GROUP_STATE_TYPE, action: PayloadAction<boolean>) {
      state.viewingStudentActivity = action.payload;
    },
    //delete group from data
  },
});

export const {
  setActiveGroupData,
  resetActiveGroupData,
  setAdminGroupsData,
  setIsEditingGroup,
  setIsGroupViewActive,
  setSelectedStudentData,
  setExpandedGroupIds,
  setViewingStudentActivity,
} = adminGroupSlice.actions;

export default adminGroupSlice.reducer;
